import React, { Fragment, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchTooltipData } from '@actions/tooltips-actions';
import ActivityLogTooltip from '@components/activity-logs/tooltips';
import { Icon } from '@mui';
import DefaultDate from '@shared/formatted-date-helper';
import './tooltip.scss';

const TaskTooltip = ({ children, id, text }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.tooltips.task[id]);
  const error = useSelector(state => state.tooltips.error.task?.[id]);

  const handleFetch = useCallback(() => {
    dispatch(fetchTooltipData('task', null, id));
  }, [dispatch, id]);

  const handleLinkClick = useCallback(() => {
    if (data) {
      window.open(`/cycle/${data.cycle}/task/${id}`, '_blank');
    }
  }, [data, id]);

  const renderTitle = useCallback(() => (
    <Fragment>
      <div styleName="body-title-icon">
        <Icon aria-hidden="true">assignment</Icon>
      </div>
      <div styleName="body-title-text">
        {data?.task_type_name}
      </div>
    </Fragment>
  ), [data]);

  const renderContent = useCallback(() => (
    <div styleName="body-content">
      <div styleName="body-row body-item">
        {data?.name}
      </div>
      <div styleName="body-row">
        Due&nbsp;<DefaultDate value={data?.due_date} />
      </div>
    </div>
  ), [data]);

  return (
    <ActivityLogTooltip
      data={data}
      error={error}
      onFetch={handleFetch}
      renderTitle={renderTitle}
      renderContent={renderContent}
      linkLabel="VIEW TASK"
      onLinkClick={handleLinkClick}
      dataType="task"
    >
      {children || text}
    </ActivityLogTooltip>
  );
};

TaskTooltip.propTypes = {
  children: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string
};

export default TaskTooltip;
